/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
// import borders from "assets/theme/base/borders";
// import colors from "assets/theme/base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

// const { borderWidth } = borders;
// const { light } = colors;

/** Matches Taxonomy category card top strip. */
const TAXONOMY_TABLE_HEAD_BG = "#F7F8FF";
const TAXONOMY_TABLE_HEAD_COLOR = "#402899";

const tableCell = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(12)} ${pxToRem(16)}`,
      border: "0.6px solid #A9A9A9",
    },
    head: {
      backgroundColor: `${TAXONOMY_TABLE_HEAD_BG} !important`,
      color: TAXONOMY_TABLE_HEAD_COLOR,
      fontWeight: 600,
    },
  },
};

export default tableCell;
